import {
  FETCH_ESCALATION_POLICIES, FETCH_ESCALATION_POLICIES_SUCCESS, FETCH_ESCALATION_POLICIES_FAIL,
  FETCH_ESCALATION_POLICY, FETCH_ESCALATION_POLICY_SUCCESS, FETCH_ESCALATION_POLICY_FAIL,
  CREATE_ESCALATION_POLICY, CREATE_ESCALATION_POLICY_SUCCESS, CREATE_ESCALATION_POLICY_FAIL,
  UPDATE_ESCALATION_POLICY, UPDATE_ESCALATION_POLICY_SUCCESS, UPDATE_ESCALATION_POLICY_FAIL,
  DELETE_ESCALATION_POLICY, DELETE_ESCALATION_POLICY_SUCCESS, DELETE_ESCALATION_POLICY_FAIL,
  TOGGLE_ESCALATION_POLICY, TOGGLE_ESCALATION_POLICY_SUCCESS, TOGGLE_ESCALATION_POLICY_FAIL,
  FETCH_ESCALATION_EVENTS, FETCH_ESCALATION_EVENTS_SUCCESS, FETCH_ESCALATION_EVENTS_FAIL,
  CLEAR_ESCALATION_MESSAGES,
} from './actionTypes';

const INIT_STATE = {
  policies: [],
  policiesLoading: false,
  policiesError: null,

  selectedPolicy: null,
  selectedPolicyLoading: false,
  selectedPolicyError: null,

  saving: false,
  saveError: null,
  saveSuccess: null,

  events: null,
  eventsLoading: false,
  eventsError: null,
};

const Escalation = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Policies list
    case FETCH_ESCALATION_POLICIES:
      return { ...state, policiesLoading: true, policiesError: null };
    case FETCH_ESCALATION_POLICIES_SUCCESS:
      return { ...state, policies: action.payload, policiesLoading: false };
    case FETCH_ESCALATION_POLICIES_FAIL:
      return { ...state, policiesLoading: false, policiesError: action.payload };

    // Single policy
    case FETCH_ESCALATION_POLICY:
      return { ...state, selectedPolicyLoading: true, selectedPolicyError: null };
    case FETCH_ESCALATION_POLICY_SUCCESS:
      return { ...state, selectedPolicy: action.payload, selectedPolicyLoading: false };
    case FETCH_ESCALATION_POLICY_FAIL:
      return { ...state, selectedPolicyLoading: false, selectedPolicyError: action.payload };

    // Create
    case CREATE_ESCALATION_POLICY:
      return { ...state, saving: true, saveError: null, saveSuccess: null };
    case CREATE_ESCALATION_POLICY_SUCCESS:
      return { ...state, saving: false, saveSuccess: 'escalation.policy_created', policies: [...state.policies, action.payload] };
    case CREATE_ESCALATION_POLICY_FAIL:
      return { ...state, saving: false, saveError: action.payload };

    // Update
    case UPDATE_ESCALATION_POLICY:
      return { ...state, saving: true, saveError: null, saveSuccess: null };
    case UPDATE_ESCALATION_POLICY_SUCCESS:
      return {
        ...state, saving: false, saveSuccess: 'escalation.policy_updated',
        policies: state.policies.map(p => p.id === action.payload.id ? action.payload : p),
      };
    case UPDATE_ESCALATION_POLICY_FAIL:
      return { ...state, saving: false, saveError: action.payload };

    // Delete
    case DELETE_ESCALATION_POLICY:
      return { ...state, saving: true, saveError: null, saveSuccess: null };
    case DELETE_ESCALATION_POLICY_SUCCESS:
      return { ...state, saving: false, saveSuccess: 'escalation.policy_deleted', policies: state.policies.filter(p => p.id !== action.payload) };
    case DELETE_ESCALATION_POLICY_FAIL:
      return { ...state, saving: false, saveError: action.payload };

    // Toggle
    case TOGGLE_ESCALATION_POLICY:
      return { ...state, saving: true, saveError: null, saveSuccess: null };
    case TOGGLE_ESCALATION_POLICY_SUCCESS:
      return {
        ...state, saving: false,
        policies: state.policies.map(p => p.id === action.payload.id ? action.payload : p),
      };
    case TOGGLE_ESCALATION_POLICY_FAIL:
      return { ...state, saving: false, saveError: action.payload };

    // Events
    case FETCH_ESCALATION_EVENTS:
      return { ...state, eventsLoading: true, eventsError: null };
    case FETCH_ESCALATION_EVENTS_SUCCESS:
      return { ...state, events: action.payload, eventsLoading: false };
    case FETCH_ESCALATION_EVENTS_FAIL:
      return { ...state, eventsLoading: false, eventsError: action.payload };

    // Clear
    case CLEAR_ESCALATION_MESSAGES:
      return { ...state, saveError: null, saveSuccess: null };

    default:
      return state;
  }
};

export default Escalation;
